var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 61,
    viewBox: "0 0 84 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.3125,
    width: 84,
    height: 60,
    rx: 29.4545,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9286_33413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.98 35.5681C41.98 35.5681 36.1129 35.1137 34.8032 29.1331C33.6605 28.7923 30.5131 23.2058 33.313 23.0388C32.9188 19.7377 32.4109 12.4807 41.98 12.4807H47.2189",
    stroke: "#148D9B",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.02 35.5681C42.02 35.5681 47.8871 35.1137 49.1968 29.1331C50.3395 28.7923 53.4869 23.2058 50.687 23.0388C50.961 20.72 51.6025 16.5369 47.6532 14.9198",
    stroke: "#148D9B",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.239 19.9315C42.8353 19.9315 38.7792 17.0314 38.7792 17.0314C38.7792 17.0314 38.2112 19.4236 36.8413 19.9315",
    stroke: "#148D9B",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9824 48.1442C25.9824 48.1442 25.5414 43.4933 28.9293 41.482C31.8362 39.945 37.5295 37.1518 37.5295 37.1518L42.02 48.1442",
    stroke: "#148D9B",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0175 48.1041C58.0175 48.1041 58.4719 43.5 55.0907 41.4887C52.1839 39.9517 46.4905 37.1585 46.4905 37.1585L42 48.1509",
    stroke: "#148D9B",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4905 37.1585L49.1634 43.4265",
    stroke: "#148D9B",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4823 48.1041H52.1505V46.4202C52.1505 44.7697 50.814 43.4265 49.1635 43.4265C47.513 43.4265 46.1765 44.763 46.1765 46.4202V48.1041H46.8447",
    stroke: "#148D9B",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5094 37.1585L34.8364 45.1105",
    stroke: "#148D9B",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8365 48.1442C35.6742 48.1442 36.3534 47.4651 36.3534 46.6274C36.3534 45.7896 35.6742 45.1105 34.8365 45.1105C33.9987 45.1105 33.3196 45.7896 33.3196 46.6274C33.3196 47.4651 33.9987 48.1442 34.8365 48.1442Z",
    stroke: "#148D9B",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8081 42.0567H44.0514",
    stroke: "#148D9B",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.3471,
    cy: 25.1303,
    r: 1.00235,
    fill: "#148D9B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.4591,
    cy: 25.1303,
    r: 1.00235,
    fill: "#148D9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3872 29.1397C41.1246 30.4829 42.715 30.4829 44.1383 29.1397",
    stroke: "#148D9B",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9286_33413"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.4116,
    height: 37,
    fill: "white",
    transform: "translate(25.2942 11.8125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutline);
export default __webpack_public_path__ + "static/media/Outline.667271870b308e4cdc928c8f80b76ddc.svg";
export { ForwardRef as ReactComponent };